module.exports = __webpack_public_path__ + "static/media/logo.288f7061.svg";